<template>
    <div class="modal-out">
      <div class="modal">
        <div class="modal-header">
          <div class="title">新增入库</div>
          <button type="button" class="btn-close" @click="closeSelf">X</button>
        </div>
        <div class="modal-body">

          <div style="padding: 10px;">

            <el-button size="mini" type="primary" plain @click="showAdd">物品添加</el-button>
          </div>

          <el-table ref="table2" class="table" size="mini" :data="waresInfo" :height="300" border>

            <el-table-column prop="name" label="物品名称"></el-table-column>
            <el-table-column prop="supplierName" label="供应商"></el-table-column>
            <el-table-column prop="waresTypeName" label="物品类型"></el-table-column>

            <el-table-column prop="count" label="入库数量"></el-table-column>
            <el-table-column prop="expiresTime" label="过期时间"></el-table-column>

            <el-table-column fixed="right" label="操作" width="100">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click.native.prevent="deleteRow(scope.$index,waresInfo)">删除</el-button>
              </template>
            </el-table-column>

          </el-table>

        </div>
        <div class="modal-footer">
          <el-button :loading="loading" type="primary" @click="confirm('addForm')">提交</el-button>
        </div>
      </div>

      <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="showModalAdd=false"
           v-on:getList='getList' v-on:getWares='getWares'></Add>

    </div>
</template>

<script>
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode,setTokenBykey,removeTokenBykey,getTokenBykey} from "@/utils/auth";

    import Add from "./Add";

    export default {
        name: "Page",

        data(){
            return{
                tableLoading:false,
                loading:false,

                showModalAdd:false,
                showModalEdit:false,
                showModalSelectWares:false,

                tableData:[],
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,

                waresInfo:[],

                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    waresArr:null,
                  remarks:'',
                },


              key:'',

            }
        },
        components:{
            Add,
        },
        methods:{

          init(){
            this.key = getStaffCode()+"-StockinInsCart";
            this.getList();
          },

          showAdd(){
            this.$refs.myAdd.init(this.institutionCode);
            this.showModalAdd = !this.showModalAdd;
          },
          closeSelf(){
            this.$emit("closeCart");
          },

          getWares(row){

            for(let i=0;i<this.waresInfo.length;i++){
              if(this.waresInfo[i].waresCode == row.waresCode){
                this.$message.info("物品已添加");
                return;
              }
            }

            this.waresInfo.push(row)
            setTokenBykey(this.key,this.waresInfo)
          },

          deleteRow(index, rows){
            rows.splice(index, 1);
            setTokenBykey(this.key,this.waresInfo)
          },

          getList(){

              this.$nextTick(()=>{
                //console.log(this.key);
                var info=getTokenBykey(this.key);
                if(info){
                  this.waresInfo=JSON.parse(info)
                }else{
                  this.waresInfo=[]
                }
                this.$refs.table2.doLayout();
              })

          },


          confirm(){
            if(this.waresInfo.length>0){

              this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
              this.addForm.waresArr=this.waresInfo;
              this.addForm.remarks = "物品入库";

              this.$axios({
                method: 'post',
                url: this.$shopUrl+"Stockin/InsAdd",
                data: this.addForm
              }).then(
                  (response) => {
                    this.loading = false;
                    if (response.data.error == 0) {
                      this.$message({type: 'success', message: '入库成功'});

                      removeTokenBykey(this.key);

                      this.$emit("closeCart");
                      this.$emit("getList");

                    }else if(response.data.error == 1){
                      this.$message({type: 'info', message: response.data.message});
                    }
                  }
              )

            }else{
              this.$message({type: 'info', message: '请选择物品'});
            }
          },


        }

    }
</script>

<style scoped>

</style>
